// import VM from '../../../main'
import Store from '@/store'
import constants from '@/services/constants/config'
import request from '@/services/request'
import api from '@/services/api'
import { AliExpressId } from '@/services/constants'
import { pipeCountryCode } from './feShowMap'
import { getPlatformEnglishName } from './common'
import { Message } from 'element-ui'
import { PLATFORM_ENUM_ALL } from '@/services/enums'
import { enumItemListToOptions } from './base'

/**
 * 获取 表单过滤器 下拉选项
 * 比如 平台 国家 店铺 货币 时间
 * @param {*} preData
 * @returns
 */
export function getCommonSelectMap(preData) {
  let commonMap = Store.state.map.commonMap // 是一个数组，{平台 国家 店铺 货币} 等信息，用户绑定了的店铺的全量
  const { platformIds, countryData, shopFlag, output = ['country', 'shop', 'currency', 'time'] } = preData
  if (Array.isArray(platformIds) && platformIds?.length) {
    commonMap = commonMap.filter(item => {
      const findIndex = platformIds.findIndex(platformId => platformId === item.platformId)
      return (findIndex >= 0)
    })
  }
  if (commonMap.length <= 0) {
    Message.warning('您的账号暂无数据权限，请到管理员账号进行数据权限配置')
  }
  // VM.$msgbox({
  //   title: '提示',
  //   message: '您的账号暂无数据权限，请到管理员账号进行数据权限配置',
  //   confirmButtonText: '确定'
  // })
  const outputObj = {}
  if (output.includes('country')) outputObj.countryObj = getCountryObj(commonMap)
  if (output.includes('shop')) outputObj.shopObj = getShopObj(commonMap, countryData, shopFlag)
  if (output.includes('currency')) outputObj.currencyObj = getCurrencyObj(commonMap, countryData)
  if (output.includes('time')) outputObj.timeObj = getTimeObj(commonMap)
  return outputObj
}

export function getCurrencySymbol(currency) { // 获取页面筛选的货币符号
  if (currency) {
    if (currency === 'CNY') {
      return '￥'
    } else if (currency === 'USD') {
      return '$'
    } else {
      const findObj = Store.state.map.allCurrencyOptions.find(item => item.currencyCode === currency)
      return findObj?.currencySymbol
    }
  } else {
    return ''
  }
}

// 获取国家信息相关
const getCountryObj = (commonMap) => {
  const filterData = [] // 去重国家的数据
  const sortList = ['US', 'CA', 'UK', 'DE', 'FR', 'IT', 'ES', 'NL', 'JP', 'AU', 'MX', 'SG', 'IN', 'SE', 'SA']
  let selectMap = []
  commonMap.forEach(map => { // 去重国家
    const findObj = filterData.find(item => item.id === map.countryCode)
    if (!findObj && map.countryCode) {
      // 前端显示映射逻辑 pipeCountryCode
      filterData.push({ id: map.countryCode, name: pipeCountryCode(map.countryCode) })
    }
  })
  sortList.forEach(countryCode => {
    const findIndex = filterData.findIndex(map => map.id === countryCode)
    if (findIndex >= 0) {
      selectMap.push(filterData[findIndex])
      filterData.splice(findIndex, 1) // 删除已排序的
    }
  })
  selectMap = [...selectMap, ...filterData]
  return { selectMap }
}

// 获取店铺信息相关
const getShopObj = (commonMap, countryData, shopFlag) => {
  let filterData = commonMap
  if (countryData?.length) {
    filterData = filterData.filter(item => {
      const findIndex = countryData.findIndex(countryCode => countryCode === item.countryCode)
      return findIndex >= 0
    })
  }
  const selectMap = []
  const treeMap = [] // tree options, level1 is [storeName], level2 is storeName + country
  const treeMapByPlatform = [] // tree options, level1 is [platform], level2 is store + country
  const childrenKeys = []
  filterData.forEach(item => {
    const isAppendCountryCode = !shopFlag && item.countryCode
    selectMap.push({
      id: item.shopId,
      name: item.shopName + (isAppendCountryCode ? ('-' + pipeCountryCode(item.countryCode)) : ''),
      countryCode: item.countryCode
    })

    childrenKeys.push(item.shopId)

    // handle treeMap
    const findObj = treeMap.find(k => k.name === item.shopName)
    if (findObj) { // 树的子节点
      findObj.children.push({
        id: item.shopId,
        // 国家码前端映射逻辑
        name: item.shopName + '-' + pipeCountryCode(item.countryCode)
      })
    } else {
      treeMap.push({ // 树的父节点
        id: `parent-${item.shopId}`,
        name: item.shopName,
        children: [{
          id: item.shopId,
          name: item.shopName + '-' + pipeCountryCode(item.countryCode)
        }]
      })
    }

    // handle treeMapByPlatform
    const curTreeMapByPlatform = treeMapByPlatform.find(treeItem => treeItem.platformId === item.platformId)
    if (curTreeMapByPlatform) {
      // already exist in tree
      curTreeMapByPlatform.children.push({
        id: item.shopId,
        // 国家码前端映射逻辑
        name: item.shopName + '-' + pipeCountryCode(item.countryCode),
        platformId: item.platformId
      })
    } else {
      const platformName = getPlatformEnglishName(item.platformId) || '其他平台'
      treeMapByPlatform.push({ // 树的父节点
        id: `parent-${item.shopId}`,
        name: platformName, // platform name
        platformId: item.platformId,
        children: [{
          id: item.shopId,
          name: item.shopName + '-' + pipeCountryCode(item.countryCode),
          platformId: item.platformId
        }]
      })
    }
  })
  return { selectMap, treeMap, treeMapByPlatform, childrenKeys }
}

// 获取货币信息相关
const getCurrencyObj = (commonMap, countryData) => {
  let initCurrency = constants.DefaultCurrency // 初始货币值
  if (countryData?.length === 1) {
    const findObj = commonMap.find(item => item.countryCode === countryData[0])
    initCurrency = findObj.currency
  }

  const filterData = []
  const sortList = ['CAD', 'GBP', 'EUR', 'JPY', 'AUD', 'MXN', 'SGD', 'INR', 'SEK', 'SAR']
  let selectMap = [{ id: 'CNY', name: 'CNY - 人民币' }, { id: 'USD', name: 'USD - 美元' }]
  commonMap.forEach(map => { // 去重货币
    const findObj = filterData.find(item => item.id === map.currency)
    if (!findObj && map.currency !== 'CNY' && map.currency !== 'USD') {
      filterData.push({ id: map.currency, name: map.currency + ' - ' + map.currencyName })
    }
  })
  sortList.forEach(currency => {
    const findIndex = filterData.findIndex(map => map.id === currency)
    if (findIndex >= 0) {
      selectMap.push(filterData[findIndex])
      filterData.splice(findIndex, 1) // 删除已排序的
    }
  })
  selectMap = [...selectMap, ...filterData]
  return { initCurrency, selectMap }
}

// 获取最大的时区
function getTimeObj(commonMap) {
  let maxTimeZone = 8 // 拥有站点的最大时区并且北京时区为最大
  let possessMaxZone = null // 拥有站点的最大时区
  commonMap.forEach(item => {
    if (possessMaxZone === null || item.timeZoneNum > possessMaxZone) possessMaxZone = item.timeZoneNum
    if (item.timeZoneNum > maxTimeZone) maxTimeZone = item.timeZoneNum
  })
  return { maxTimeZone, possessMaxZone }
}

// 获取用户授权的所有平台
export function getUserPlatformOptions() {
  const commonMap = Store.state.map.commonMap // 是一个数组，{平台 国家 店铺 货币} 等信息，用户绑定了的店铺的全量
  const ret = {} // { platformId: {id, name} }

  commonMap.forEach((store) => {
    const { platformId } = store
    if (!ret[platformId]) {
      ret[platformId] = {
        id: platformId,
        name: getPlatformEnglishName(platformId)
      }
    }
  })

  return Object.values(ret)
}

/**
 * 获取已授权的【站点-店铺】级联数据 cascader组件
 * @param {} platformId
 */
export function getGrantedCountryShopCascaderOptions(platformId) {
  // 没有指定平台，返回空数组
  if (!platformId) {
    return []
  }

  const commonMap = Store.state.map.commonMap // 是一个数组，{平台 国家 店铺 货币} 等信息，用户绑定了的店铺的全量
  const filteredShop = commonMap.filter(
    (item) => item.platformId === platformId
  )
  const ret = {} // values 是需要返回的

  filteredShop.forEach((shop) => {
    const { countryCode, shopId, shopName } = shop
    if (!ret[countryCode]) {
      // add
      ret[countryCode] = {
        label: countryCode,
        value: countryCode,
        children: [
          {
            ...shop,
            value: shopId,
            label: shopName
          }
        ]
      }
    } else {
      // append
      ret[countryCode].children.push({
        ...shop,
        value: shopId,
        label: shopName
      })
    }
  })

  return Object.values(ret)
}

/**
 * 获取已授权的【站点-店铺】级联数据 cascader组件
 * @param {} platformId
 */
export function getGrantedCountryShopOptions(platformId) {
  // 没有指定平台，返回空数组
  if (!platformId) {
    return []
  }

  const commonMap = Store.state.map.commonMap // 是一个数组，{平台 国家 店铺 货币} 等信息，用户绑定了的店铺的全量
  const filteredShop = commonMap.filter(
    (item) => item.platformId === platformId
  )
  return filteredShop.map(shop => {
    const { countryCode, shopId, shopName } = shop
    let label = shopName
    if (shop.platformId !== AliExpressId) {
      // 非速卖通 平台要加上国家
      label = `${shopName}-${countryCode}`
    }

    return {
      ...shop,
      value: shopId,
      label
    }
  })
}

/**
 * 获取币种可选项  已授权的店铺站点
 */
export function getGrantedCurrencyOptions() {
  const originStoreArr = Store.state.map.commonMap // 是一个数组，{平台 国家 店铺 货币} 等信息，用户绑定了的店铺的全量
  const ret = {} // values 是需要返回的

  originStoreArr.forEach(store => {
    const { currency, currencyName } = store
    if (!ret[currency]) {
      const curOption = {
        currencyCode: currency,
        currencyName,
        label: `${currency} - ${currencyName}`,
        value: currency
      }
      ret[currency] = (curOption)
    }
  })

  return Object.values(ret)
}

/**
 * 获取商品品牌
 */
export async function getAllBrand() {
  const { code, data } = await request(api.common.getAllBrand)
  let map = []
  if (code === 200) {
    map = data.map(item => {
      return {
        id: item,
        name: item,
      }
    })
  }
  return map
}

/**
 * 获取商品分类
 */
export async function getAllGoodsClass() {
  const { code, data } = await request(api.common.getAllGoodsClass)
  const childrenKeys = []
  if (code === 200) {
    changClassPropertyName(data, childrenKeys)
  }
  return {
    treeMap: data || [],
    childrenKeys
  }
}
function changClassPropertyName(data, childrenKeys) {
  data.forEach(item => {
    item.id = item.name = item.goodsClass
    childrenKeys.push(item.id)
    if (item.children && item.children.length > 0) {
      changClassPropertyName(item.children, childrenKeys)
    }
  })
}

/**
 * 获取运营负责人
 */
export async function getChargerList() {
  const { code, data } = await request(api.common.getChargerList)
  let map = []
  if (code === 200) {
    map = data
  }
  return map
}

export function getGrantedPlatformOptions() {
  const commonMap = Store.state.map.commonMap // 是一个数组，{平台 国家 店铺 货币} 等信息，用户绑定了的店铺的全量
  const platformIds = commonMap.map(
    (item) => item.platformId
  )

  const options = []
  Object.values(PLATFORM_ENUM_ALL).forEach(item => {
    const isGranted = platformIds.includes(item.value)
    if (isGranted) {
      options.push(item)
    }
  })

  return enumItemListToOptions(options)
}
